import Layout from '@/layout'

const activity = {
  path: '/activity',
  name: 'ActivityList',
  component: Layout,
  title: '活动预告',

  redirect: '/activity',
  meta: { title: '活动预告', name: 'ActivityList' },
  children: [
    {
      path: '',
      name: 'Trailer',
      component: () => import('@/views/Activity/index.vue'),
      meta: { title: '活动预约' }
    },
    {
      path: 'mine',
      name: 'ActivityMine',
      component: () => import('@/views/Activity/mine.vue'),
      meta: { title: '我的活动' }
    },
    {
      path: 'homeWork',
      name: 'homeWork',
      component: () => import('@/views/Activity/homeWork.vue'),
      meta: { title: '活动作业' }
    },
    {
      path: 'detail/:id',
      name: 'ActivityDetail',
      component: () => import('@/views/Activity/detail.vue'),
      meta: { title: '活动详情', hidden: true }
    },
    {
      path: 'activity-assessment/:id',
      name: 'ActivityAssessment',
      component: () => import('@/views/MyCourse/Assessment/detail'),
      meta: { title: '活动评估详情', hidden: true }
    }
  ]
}

export default activity
